import { createContext, PropsWithChildren, useContext } from "react";

import { IContext } from "@src/context";

type IAppContext = IContext;

const AppContext = createContext<IAppContext | null>(null);

function AppContextProvider({
  children,
  appContext,
}: PropsWithChildren<{ appContext: IAppContext }>) {
  return (
    <AppContext.Provider value={appContext}>{children}</AppContext.Provider>
  );
}

function useAppContext() {
  const ctx = useContext(AppContext);

  if (ctx == null) {
    throw new Error("No AppContext Provided");
  }

  return ctx;
}

export { AppContextProvider, useAppContext };
